require('/ui/components/table/body/tablebody.module.scss.module.css');

export const cell = "_cell_1nl76_1";
export const cellContents = "_cell-contents_1nl76_1";
export const emptyContent = "_empty-content_1nl76_1";
export const emptyContentContainer = "_empty-content-container_1nl76_1";
export const emptyContentRow = "_empty-content-row_1nl76_1";
export const emptyContentTitle = "_empty-content-title_1nl76_1";
export const smallViewportSupport = "_small-viewport-support_1nl76_1";
export const emptyContentBody = "_empty-content-body_1nl76_1";
export const callToActionCell = "_call-to-action-cell_1nl76_1";
export const callToActionContents = "_call-to-action-contents_1nl76_1";
export const selectCell = "_select-cell_1nl76_1";
